var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-toast',{attrs:{"id":"example-toast","toaster":"b-toaster-bottom-right mb-5","variant":_vm.alertOptions.variant,"no-close-button":"","solid":"","auto-hide-delay":_vm.alertOptions.delay}},[_c('i',{staticClass:"icon-info-circled"}),_vm._v(" "+_vm._s(_vm.alertOptions.message)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }